<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
<ng-container *transloco="let t">
  <section class="product-category-filter-component" [class.pill-mode]="pillMode">
    @if ((productOptions$ | async)?.category?.length || 0 > 0) {
      <nav class="nav" [class.mobile-mode]="mobileMode" [class.list-mode]="gridMode">
        @if (!mobileMode && !gridMode) {
          <a
            class="link"
            (click)="switchCategoryFilter('label_all')"
            [class.selected]="!phoneFilterOptions?.category?.length">
            <span>{{ t('label_all_products') }}</span>
          </a>
        }
        @if (!gridMode) {
          <span class="fixed-space-24" aria-hidden="true"></span>
        }
        @if (!gridMode && !pillMode) {
          <span class="fixed-space-16" aria-hidden="true"></span>
        }
        @for (
          category of (productOptions$ | async)?.category;
          track trackByModel($index, category)
        ) {
          <a
            class="link"
            (click)="switchCategoryFilter(category)"
            [class.selected]="phoneFilterOptions?.category?.includes(category)">
            <span>
              {{
                t(
                  'category_' +
                    (capitalizeCategory(category)?.toLowerCase() || '') +
                    '_title'
                )
              }}
            </span>
          </a>
          <span aria-hidden="true" class="fixed-space-24"></span>
          @if (mobileMode) {
            <span class="line"></span>
          }
          @if (!pillMode) {
            <span aria-hidden="true" class="fixed-space-16"></span>
          }
        }
      </nav>
    }

    <!-- eskeleton -->
    @if (!(productOptions$ | async)?.category?.length || 0 > 0) {
      <nav class="nav" [class.mobile-mode]="mobileMode" [class.list-mode]="gridMode">
        <popsy-skeleton class="skeleton" aria-hidden="true"></popsy-skeleton>
        <span aria-hidden="true" class="fixed-space-24"></span>
        <popsy-skeleton class="skeleton" aria-hidden="true"></popsy-skeleton>
        <span aria-hidden="true" class="fixed-space-24"></span>
        <popsy-skeleton class="skeleton" aria-hidden="true"></popsy-skeleton>
      </nav>
    }
  </section>
</ng-container>
